module.exports = __webpack_public_path__ + "static/media/DownloadButton.1d48363a.svg";